module.exports = __webpack_public_path__ + "media/images/icon-changer-9bd2627d723d85cc91a58ef00c5ec4cb.svg";